import { Textarea } from "flowbite-react";
import { useRef, useState } from "react";
import toast from "react-hot-toast";
import { FaLocationArrow } from "react-icons/fa";
import OverlayPreloader from "../../preloaders/OverlayPreloader";
import { sendOutgoingMessage } from "../../../api/conversations";

const SendMessage = ({ conversationId, fetchInfluencer }) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleChange = e => {
    setMessage(e.target.value);
    adjustTextareaHeight();
  }

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }

  const handleSendMessage = async () => {
    setLoading(true);

    try {
      await sendOutgoingMessage({
        id: conversationId,
        data: { message },
      });

      await fetchInfluencer();

      setMessage('');
    } catch (error) {
      console.error(error);
      toast.error('Failed to process message');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="absolute bottom-0 left-0 w-full">
      <div className="w-full border-t border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-700">
        <div className="flex items-center gap-4 bg-white px-4 py-3 dark:bg-gray-800">
          <label htmlFor="ai-chat-input" className="sr-only">Write message</label>
          <Textarea
            name="inputMessage"
            id="inputMessage"
            ref={textareaRef}
            placeholder="Enter a message..."
            value={message}
            onChange={handleChange}
            rows={1}
            className="resize-none overflow-hidden w-full border-0 bg-white text-sm text-gray-800 focus:ring-0 dark:bg-gray-800 dark:text-white dark:placeholder:text-gray-400 p-2 rounded-md"
            style={{
              minHeight: '40px',
              maxHeight: '150px',
            }}
          />
          <button
            type="submit"
            className="inline-flex cursor-pointer justify-center rounded-full p-2 dark:hover:bg-gray-600"
            disabled={!message}
            onClick={handleSendMessage}
          >
            <FaLocationArrow className="size-4 rotate-45" />
            <span className="sr-only">Send message</span>
          </button>
        </div>
      </div>
      {loading && <OverlayPreloader />}
    </div>
  )
}

export default SendMessage;